import { useEffect } from 'react';
import { Form } from 'antd';

export const usePatientForm = (form) => {
  // Calculate BMI automatically
  const calculateBMI = (weight, height) => {
    if (!weight || !height) return null;
    const heightInMeters = height / 100;
    const bmi = weight / (heightInMeters * heightInMeters);
    return Math.round(bmi * 10) / 10;
  };

  // Watch form values to calculate BMI automatically
  const formValues = Form.useWatch([], form);
  
  useEffect(() => {
    if (formValues) {
      const { weight, height } = formValues;
      const bmi = calculateBMI(weight, height);
      if (bmi !== null && form.getFieldValue('bmi') !== bmi) {
        form.setFieldsValue({ bmi });
      }
    }
  }, [formValues, form]);

  return {
    formValues,
    calculateBMI
  };
};